import {DateSchema} from '@cohort/shared/schema/common';
import type {
  UserPropertyDataType,
  UserPropertyValue,
} from '@cohort/shared/schema/common/userProperty';
import {match} from 'ts-pattern';
import type {SafeParseReturnType} from 'zod';
import {z} from 'zod';

export function getParser(dataType: UserPropertyDataType): z.ZodSchema {
  const parser = match(dataType)
    .with('boolean', () => z.boolean())
    .with('date', () => DateSchema)
    .with('number', () => z.number())
    .with('string', () => z.string())
    .exhaustive();
  return parser;
}

export function parseValue(dataType: UserPropertyDataType, value: unknown): UserPropertyValue {
  return getParser(dataType).parse(value);
}

export function safeParseValue(
  dataType: UserPropertyDataType,
  value: unknown
): SafeParseReturnType<unknown, UserPropertyValue> {
  return getParser(dataType).safeParse(value);
}
